import React from 'react';
import { Paper, Box, Typography } from '@mui/material';

const WorkAreaItem = ({
    icon: IconComponent,
    label,
    description,
    isActive = false,
    isEven = false,
    delay = 0,
    FadeInSection,
    ctaButton = null,
    onClick = null
}) => {
    return (
        <FadeInSection delay={delay}>
            <Paper
                elevation={isActive ? 8 : 2}
                onClick={!isActive && onClick ? onClick : undefined}
                sx={{
                    p: 4,
                    borderRadius: 4,
                    bgcolor: isActive ? 'white' : 'white',
                    border: isActive ? '2px solid' : '2px solid',
                    borderColor: isActive ? 'primary.main' : 'blue.300',
                    position: 'relative',
                    overflow: 'hidden',
                    height: '100%',
                    minHeight: { xs: 'auto', md: '420px' },
                    display: 'flex',
                    flexDirection: 'column',
                    cursor: !isActive && onClick ? 'pointer' : 'default',
                    '&:hover': isActive ? {
                        transform: 'translateY(-8px)',
                        boxShadow: '0 25px 50px rgba(199, 154, 95, 0.15)'
                    } : !isActive && onClick ? {
                        transform: 'translateY(-4px)',
                        boxShadow: '0 15px 30px rgba(25, 118, 210, 0.15)',
                        borderColor: 'blue.400',
                        bgcolor: 'blue.50'
                    } : {},
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    ...(isActive && {
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '5px',
                            background: 'linear-gradient(90deg, #c79a5f, #9b7b5e)'
                        }
                    }),
                    ...(!isActive && onClick && {
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '5px',
                            background: 'linear-gradient(90deg, #1976d2, #1565c0)'
                        }
                    })
                }}
            >
                {/* Active Badge */}
                {isActive && (
                    <Box sx={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        bgcolor: 'primary.main',
                        color: 'white',
                        px: 2,
                        py: 0.5,
                        borderRadius: 2,
                        fontSize: '0.75rem',
                        fontWeight: 'bold'
                    }}>
                        DOSTĘPNE
                    </Box>
                )}

                {/* Coming Soon Badge for Inactive Areas */}
                {!isActive && onClick && (
                    <Box sx={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        bgcolor: 'blue.500',
                        color: 'white',
                        px: 2,
                        py: 0.5,
                        borderRadius: 2,
                        fontSize: '0.75rem',
                        fontWeight: 'bold'
                    }}>
                        WKRÓTCE
                    </Box>
                )}

                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    height: '100%'
                }}>
                    {/* Icon */}
                    <Box sx={{
                        display: 'inline-flex',
                        p: 3,
                        borderRadius: '50%',
                        bgcolor: isActive ? 'grey.100' : 'blue.50',
                        border: isActive ? '3px solid' : '3px solid',
                        borderColor: isActive ? 'primary.main' : 'blue.400',
                        mb: 3
                    }}>
                        <IconComponent sx={{
                            fontSize: { xs: 50, md: 60 },
                            color: isActive ? 'primary.main' : 'blue.600'
                        }} />
                    </Box>

                    {/* Content */}
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 'bold',
                            color: isActive ? 'grey.800' : 'blue.700',
                            mb: 2,
                            fontSize: { xs: '1.5rem', md: '1.75rem' }
                        }}
                    >
                        {label}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: isActive ? 'grey.700' : 'blue.600',
                            lineHeight: 1.6,
                            fontSize: '1rem',
                            mb: 'auto',
                            flexGrow: 1
                        }}
                    >
                        {description}
                    </Typography>

                    {/* CTA Button for Active Items */}
                    {isActive && ctaButton && (
                        <Box sx={{
                            mt: 3,
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            {ctaButton}
                        </Box>
                    )}

                    {/* Clickable Message for Inactive Items */}
                    {!isActive && onClick && (
                        <Box sx={{
                            mt: 3,
                            p: 2,
                            borderRadius: 2,
                            bgcolor: 'blue.50',
                            border: '1px solid',
                            borderColor: 'blue.200',
                            width: '100%',
                            cursor: 'pointer',
                            '&:hover': {
                                bgcolor: 'blue.100',
                                borderColor: 'blue.300'
                            },
                            transition: 'all 0.2s ease'
                        }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: 'blue.700',
                                    fontWeight: 'medium',
                                    textAlign: 'center',
                                    mb: 0.5
                                }}
                            >
                                🚀 Kliknij, aby się zapisać
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: 'blue.600',
                                    textAlign: 'center',
                                    fontSize: '0.875rem'
                                }}
                            >
                                Powiadomimy Cię gdy będzie gotowy!
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Paper>
        </FadeInSection>
    );
};

export default WorkAreaItem;
